import {PermissionsModel} from "../../../entity/permissions.model";
import {IWithPermissionModel} from "./iWithPermission.model";

export abstract class WithPermissionModel implements IWithPermissionModel {
    permissions: PermissionsModel;
}